import { crudActions, crudMutations, crudGetters } from "@/utils/store";

const BASE_URL = '/admin/icon_tags/'

export const state = () => ({
  objects: [],
  total: 0
})

export const mutations = { ...crudMutations }

export const actions = { ...crudActions(BASE_URL) }

export const getters = { ...crudGetters }
